import React from "react";

const MediaPreviewInPlaylist = ({ matchedRecord }) => {
  if (!matchedRecord) return <div>No preview available</div>;

  const isTemplate = !!matchedRecord?.customProperties?.html;
  const isContentAI = matchedRecord?.id === "content-ai";

  // Extract the correct imageUrl
  const imageUrl = isContentAI
    ? matchedRecord?.imageUrl
    : !isTemplate
    ? matchedRecord?.customisations?.[0]?.imageUrl
    : null;

  // Extract relevant properties
  const { customProperties, name } = matchedRecord;

  // Render HTML content inside an iframe
  if (customProperties?.html) {
    return (
      <iframe
        srcDoc={customProperties.html}
        title={name || "HTML Preview"}
        style={{
          height: "100%",
          width: "100%",
          border: "none",
          backgroundColor: "#f9f9f9",
        }}
      />
    );
  }

  // Determine if the content is a video
  if (imageUrl) {
    const videoExtensions = [".mp4", ".avi", ".mov"];
    const isVideo = videoExtensions.some((ext) =>
      imageUrl.toLowerCase().endsWith(ext)
    );

    return isVideo ? (
      <video
        src={imageUrl}
        controls
        style={{
          height: "100%",
          width: "100%",
          objectFit: "cover",
        }}
      />
    ) : (
      <img
        src={imageUrl}
        alt={name || "Preview"}
        style={{
          height: "100%",
          width: "100%",
          objectFit: "cover",
        }}
      />
    );
  }

  return <div>{name || "Content not available"}</div>;
};

export default MediaPreviewInPlaylist;
